// packages/agent-kit/src/hooks/user/useUserProfile.ts
import useSWR from 'swr';
import { userService, isApiError } from '@dopomogai/api-client';
import { useIsLoading, useUser } from '@dopomogai/supabase-client/react';
import type { UserDB } from '@dopomogai/types';
import { AgentKitError } from '../types'; // Path updated

/**
 * Hook to get the user's full profile.
 */
export const useUserProfile = () => {
  const authUser = useUser();
  const isAuthLoading = useIsLoading();

  const { data, error, isLoading, mutate } = useSWR<UserDB, AgentKitError>(
    !isAuthLoading && authUser ? '/users/me' : null,
    async () => {
      const res = await userService.getProfile();
      if (isApiError(res)) throw new AgentKitError('Failed to fetch user profile', res);
      return res;
    },
    {
      revalidateOnFocus: false,
    }
  );

  return {
    user: data,
    error,
    isLoading: isAuthLoading || (!!authUser && isLoading),
    mutateProfile: mutate,
  };
};
